import { dtsAPI } from "../../axios";

export const actions = {

    // Track Document
    GetTrackDocument(context, data){
        return dtsAPI.get(`TrackDocument/Track/${data}`);
    },
    GetSingleTrackDocument(context, data){
        return dtsAPI.get(`TrackDocument/${data}`);
    },
    UpdateTrackDocument(context, data){
        return dtsAPI.put(`TrackDocument/${data.id}`, data);
    },
    DeleteTrackDocument(context, data){
        return dtsAPI.delete(`TrackDocument/${data}`);
    },
    CreateTrackDocument(context, data){
        return dtsAPI.post(`TrackDocument/${data.trackId}`, data.documents);
    },

}